<template>
  <div id="navbar">
    <v-navigation-drawer
      app
      :clipped="$vuetify.breakpoint.mdAndUp"
      dark
      fixed
      id="main-navbar"
      left
      temporary
      v-model="drawer"
      width="220"
    >
      <v-container grid-list-xs pb-0>
        <!-- Logo -->
        <v-layout align-center justify-center row wrap>
          <v-flex py-2 xs4>
            <router-link class style="cursor: pointer" tag="span" to="/dashboard">
              <v-img
                alt="Intranet Portal"
                class="navbar-logo-img"
                contain
                src="/static/images/Logo_TechFarm_White.png"
              ></v-img>
            </router-link>
          </v-flex>
        </v-layout>
        <!-- Profile Bar -->
        <v-layout align-center justify-center row text-xs-center v-if="navbarUserProfile" wrap>
          <v-flex py-2 xs6>
            <v-avatar color="grey lighten-4" size="80" :tile="false">
              <v-img
                class="white"
                cover
                :src="navbarUserProfile.picture ? navbarUserProfile.picture : require('@/assets/NoPicture.png')"
                style="border:3px #fff solid;border-radius:50%"
              >
                <v-layout align-center fill-height justify-center ma-0 slot="placeholder">
                  <v-progress-circular color="grey lighten-5" indeterminate></v-progress-circular>
                </v-layout>
              </v-img>
            </v-avatar>
          </v-flex>
        </v-layout>
        <v-layout align-center justify-center row text-xs-center v-if="navbarUserProfile" wrap>
          <v-flex mt-2 xs12>
            <div
              class="body-1 text-uppercase"
              style="line-height: 12px;color:#c8cfd3"
            >{{ navbarUserProfile.engfirstname || 'ไม่ได้ระบุชื่อ' }}</div>
          </v-flex>
          <v-flex xs12>
            <div class="grey--text caption font-weight-light">{{ navbarUserProfile.roleName || '' }}</div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-list dense id="menu-list">
        <!-- Group Favorite -->
        <template v-for="item in menuPersonalFavorite">
          <v-list-group :key="item.title" v-if="item.children">
            <!--  First Menu -->
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>

            <div :key="i" v-for="(child, i) in item.children">
              <!-- Second None Group Menu -->
              <v-list-tile slot="activator">
                <v-list-tile-title
                  class="none-group-menu"
                  @click="$router.push(child.link)"
                >{{ child.title }}</v-list-tile-title>
                <!-- remove -->
                <v-icon
                  class="favorite-menu"
                  @click="deleteFromFavorite(child.link)"
                  color="red"
                  small
                >remove</v-icon>
              </v-list-tile>
            </div>
          </v-list-group>
          <v-list-tile :key="item.title" router slot="activator" :to="item.link" v-else>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </template>

        <!-- Group Main -->
        <template v-for="item in menuItemsGroupMain">
          <v-list-tile :key="item.title" router :to="item.link">
            <!-- <v-list-tile-action> -->
            <!-- <v-icon>{{ item.icon }}</v-icon> -->
            <!-- </v-list-tile-action> -->
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        <!-- Group Product Management -->
        <template v-for="item in menuItemsGroupProductManagement">
          <v-list-tile :key="item.title" router :to="item.link">
            <!-- <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>-->
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        <!-- <v-divider dark class="my-0"></v-divider> -->
        <v-subheader class="grey--text text--accent-1 subheader-group1 mt-2">Product Management</v-subheader>

        <!-- Group Classification -->
        <template v-for="item in menuItemsGroupClassification">
          <v-list-group :key="item.title" v-if="item.children">
            <!--  First Menu -->
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>

            <div :key="i" v-for="(child, i) in item.children">
              <!-- Second Group Menu -->
              <v-list-group
                no-action
                prepend-icon="keyboard_arrow_down"
                sub-group
                v-if="child.children"
              >
                <v-list-tile router slot="activator" :to="child.link">
                  <v-list-tile-title v-text="child.title"></v-list-tile-title>
                  <!-- <v-list-tile-action>
                    <v-icon color="white">{{ child.model ? child.icon : child['icon-alt'] }}</v-icon>
                  </v-list-tile-action>-->
                </v-list-tile>

                <div v-if="child.children">
                  <v-list-tile :key="i" v-for="(child, i) in child.children">
                    <v-list-tile-title
                      @click="$router.push(child.link)"
                      @contextmenu="show($event, child.title, child.link)"
                      v-text="child.title"
                    ></v-list-tile-title>
                  </v-list-tile>
                </div>
              </v-list-group>
              <!-- Second None Group Menu -->
              <v-list-tile slot="activator" v-else>
                <v-list-tile-title
                  class="none-group-menu"
                  @click="$router.push(child.link)"
                  @contextmenu="show($event, child.title, child.link)"
                >{{ child.title }}</v-list-tile-title>
              </v-list-tile>
            </div>
          </v-list-group>
          <v-list-tile :key="item.title" router slot="activator" :to="item.link" v-else>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </template>

        <!-- Group Product Components -->
        <template v-for="item in menuItemsGroupProductComponents">
          <v-list-group :key="item.title" v-if="item.children">
            <!--  First Menu -->
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>

            <div :key="i" v-for="(child, i) in item.children">
              <!-- Second Group Menu -->
              <v-list-group
                no-action
                prepend-icon="keyboard_arrow_down"
                sub-group
                v-if="child.children"
              >
                <v-list-tile router slot="activator" :to="child.link">
                  <v-list-tile-title v-text="child.title"></v-list-tile-title>
                  <!-- <v-list-tile-action>
                    <v-icon color="white">{{ child.model ? child.icon : child['icon-alt'] }}</v-icon>
                  </v-list-tile-action>-->
                </v-list-tile>

                <div v-if="child.children">
                  <v-list-tile :key="i" v-for="(child, i) in child.children">
                    <v-list-tile-title
                      @click="$router.push(child.link)"
                      @contextmenu="show($event, child.title, child.link)"
                      v-text="child.title"
                    ></v-list-tile-title>
                  </v-list-tile>
                </div>
              </v-list-group>
              <!-- Second None Group Menu -->
              <v-list-tile slot="activator" v-else>
                <v-list-tile-title
                  class="none-group-menu"
                  @click="$router.push(child.link)"
                  @contextmenu="show($event, child.title, child.link)"
                >{{ child.title }}</v-list-tile-title>
              </v-list-tile>
            </div>
          </v-list-group>
          <v-list-tile :key="item.title" router slot="activator" :to="item.link" v-else>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </template>

        <!-- Group FarmerSpace -->
        <template v-for="item in menuItemsGroupFarmerSpace">
          <v-list-group :key="item.title" v-if="item.children">
            <!--  First Menu -->
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>

            <div :key="i" v-for="(child, i) in item.children">
              <!-- Second Group Menu -->
              <v-list-group
                no-action
                prepend-icon="keyboard_arrow_down"
                sub-group
                v-if="child.children"
              >
                <v-list-tile router slot="activator" :to="child.link">
                  <v-list-tile-title v-text="child.title"></v-list-tile-title>
                  <!-- <v-list-tile-action>
                    <v-icon color="white">{{ child.model ? child.icon : child['icon-alt'] }}</v-icon>
                  </v-list-tile-action>-->
                </v-list-tile>

                <div v-if="child.children">
                  <v-list-tile :key="i" v-for="(child, i) in child.children">
                    <v-list-tile-title
                      @click="$router.push(child.link)"
                      @contextmenu="show($event, child.title, child.link)"
                      v-text="child.title"
                    ></v-list-tile-title>
                  </v-list-tile>
                </div>
              </v-list-group>
              <!-- Second None Group Menu -->
              <v-list-tile slot="activator" v-else>
                <v-list-tile-title
                  class="none-group-menu"
                  @click="$router.push(child.link)"
                  @contextmenu="show($event, child.title, child.link)"
                >{{ child.title }}</v-list-tile-title>
              </v-list-tile>
            </div>
          </v-list-group>
          <v-list-tile :key="item.title" router slot="activator" :to="item.link" v-else>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </template>

        <!-- Group Cropperz -->
        <template v-for="item in menuItemsGroupCropperz">
          <v-list-group :key="item.title" v-if="item.children">
            <!--  First Menu -->
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>

            <div :key="i" v-for="(child, i) in item.children">
              <!-- Second Group Menu -->
              <v-list-group
                no-action
                prepend-icon="keyboard_arrow_down"
                sub-group
                v-if="child.children"
              >
                <v-list-tile router slot="activator" :to="child.link">
                  <v-list-tile-title v-text="child.title"></v-list-tile-title>
                  <!-- <v-list-tile-action>
                    <v-icon color="white">{{ child.model ? child.icon : child['icon-alt'] }}</v-icon>
                  </v-list-tile-action>-->
                </v-list-tile>

                <div v-if="child.children">
                  <v-list-tile :key="i" v-for="(child, i) in child.children">
                    <v-list-tile-title
                      @click="$router.push(child.link)"
                      @contextmenu="show($event, child.title, child.link)"
                      v-text="child.title"
                    ></v-list-tile-title>
                  </v-list-tile>
                </div>
              </v-list-group>
              <!-- Second None Group Menu -->
              <v-list-tile slot="activator" v-else>
                <v-list-tile-title
                  class="none-group-menu"
                  @click="$router.push(child.link)"
                  @contextmenu="show($event, child.title, child.link)"
                >{{ child.title }}</v-list-tile-title>
              </v-list-tile>
            </div>
          </v-list-group>
          <v-list-tile :key="item.title" router slot="activator" :to="item.link" v-else>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </template>

        <!-- Group Control Panel -->
        <div v-if="permissionControlPanel">
          <template v-for="item in menuItemsGroupControlPanel">
            <v-list-group :key="item.title" v-if="item.children">
              <!--  First Menu -->
              <v-list-tile slot="activator">
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>

              <div :key="i" v-for="(child, i) in item.children">
                <!-- Second Group Menu -->
                <v-list-group
                  no-action
                  prepend-icon="keyboard_arrow_down"
                  sub-group
                  v-if="child.children"
                >
                  <v-list-tile router slot="activator" :to="child.link">
                    <v-list-tile-title v-text="child.title"></v-list-tile-title>
                    <!-- <v-list-tile-action>
                    <v-icon color="white">{{ child.model ? child.icon : child['icon-alt'] }}</v-icon>
                    </v-list-tile-action>-->
                  </v-list-tile>

                  <div v-if="child.children">
                    <v-list-tile :key="i" v-for="(child, i) in child.children">
                      <v-list-tile-title
                        @click="$router.push(child.link)"
                        @contextmenu="show($event, child.title, child.link)"
                        v-text="child.title"
                      ></v-list-tile-title>
                    </v-list-tile>
                  </div>
                </v-list-group>
                <!-- Second None Group Menu -->
                <v-list-tile slot="activator" v-else>
                  <v-list-tile-title
                    class="none-group-menu"
                    @click="$router.push(child.link)"
                    @contextmenu="show($event, child.title, child.link)"
                  >{{ child.title }}</v-list-tile-title>
                </v-list-tile>
              </div>
            </v-list-group>
            <v-list-tile :key="item.title" router slot="activator" :to="item.link" v-else>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </template>
        </div>

        <!-- Group Techfarm -->
        <template v-for="item in menuItemsGroupTechfarm">
          <v-list-group :key="item.title" v-if="item.children">
            <!--  First Menu -->
            <v-list-tile slot="activator">
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>

            <div :key="i" v-for="(child, i) in item.children">
              <!-- Second Group Menu -->
              <v-list-group
                no-action
                prepend-icon="keyboard_arrow_down"
                sub-group
                v-if="child.children"
              >
                <v-list-tile router slot="activator" :to="child.link">
                  <v-list-tile-title v-text="child.title"></v-list-tile-title>
                  <!-- <v-list-tile-action>
                    <v-icon color="white">{{ child.model ? child.icon : child['icon-alt'] }}</v-icon>
                  </v-list-tile-action>-->
                </v-list-tile>

                <div v-if="child.children">
                  <v-list-tile :key="i" v-for="(child, i) in child.children">
                    <v-list-tile-title
                      @click="$router.push(child.link)"
                      @contextmenu="show($event, child.title, child.link)"
                      v-text="child.title"
                    ></v-list-tile-title>
                  </v-list-tile>
                </div>
              </v-list-group>
              <!-- Second None Group Menu -->
              <v-list-tile slot="activator" v-else>
                <v-list-tile-title
                  class="none-group-menu"
                  @click="$router.push(child.link)"
                  @contextmenu="show($event, child.title, child.link)"
                >{{ child.title }}</v-list-tile-title>
              </v-list-tile>
            </div>
          </v-list-group>
          <v-list-tile :key="item.title" router slot="activator" :to="item.link" v-else>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </template>

        <!-- Group User Management -->
        <div v-if="permissionUserManagement">
          <template v-for="item in menuItemsGroupUserManagement">
            <v-list-group :key="item.title" v-if="item.children">
              <!--  First Menu -->
              <v-list-tile slot="activator">
                <v-list-tile-title>{{ item.title }}</v-list-tile-title>
              </v-list-tile>

              <div :key="i" v-for="(child, i) in item.children">
                <!-- Second Group Menu -->
                <v-list-group
                  no-action
                  prepend-icon="keyboard_arrow_down"
                  sub-group
                  v-if="child.children"
                >
                  <v-list-tile router slot="activator" :to="child.link">
                    <v-list-tile-title v-text="child.title"></v-list-tile-title>
                    <!-- <v-list-tile-action>
                    <v-icon color="white">{{ child.model ? child.icon : child['icon-alt'] }}</v-icon>
                    </v-list-tile-action>-->
                  </v-list-tile>

                  <div v-if="child.children">
                    <v-list-tile :key="i" v-for="(child, i) in child.children">
                      <v-list-tile-title
                        @click="$router.push(child.link)"
                        @contextmenu="show($event, child.title, child.link)"
                        v-text="child.title"
                      ></v-list-tile-title>
                    </v-list-tile>
                  </div>
                </v-list-group>
                <!-- Second None Group Menu -->
                <v-list-tile slot="activator" v-else>
                  <v-list-tile-title
                    class="none-group-menu"
                    @click="$router.push(child.link)"
                    @contextmenu="show($event, child.title, child.link)"
                  >{{ child.title }}</v-list-tile-title>
                </v-list-tile>
              </div>
            </v-list-group>
            <v-list-tile :key="item.title" router slot="activator" :to="item.link" v-else>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>
          </template>
        </div>

        <!-- Group Logout -->
        <div class="mt-5"></div>
        <template v-for="item in menuItemsGroupLogout">
          <v-list-tile :key="item.title" router :to="item.link">
            <!-- <v-list-tile-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>-->
            <v-list-tile-content>
              <v-list-tile-title v-if="item.title != 'Logout'">{{ item.title }}</v-list-tile-title>
              <v-list-tile-title @click="doLogout" style="cursor: pointer;" v-else>Logout</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
        <div class="mt-5"></div>
      </v-list>
    </v-navigation-drawer>

    <v-toolbar app :clipped-left="$vuetify.breakpoint.mdAndUp" dark id="toolbar-desktop">
      <v-toolbar-side-icon @click.native.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title class="mr-5 align-center">
        <router-link class="hidden-sm-and-down" style="cursor: pointer" tag="span" to="/dashboard">
          <img alt="Intranet Portal" class="logo-img" src="/static/images/Logo_Portal.png" />
          <!-- <img class="logo-img" src="/static/images/Logo_TechFarm_White.png" alt="Intranet Portal"> -->
        </router-link>
      </v-toolbar-title>
      <v-layout align-center row style="max-width: 650px">
        <!-- <v-autocomplete
          label="ค้นหา"
          class="white--text"
          autocomplete
          single-line
          hide-details
          item-text="productname"
          item-value="productid"
          :items="states"
          v-model="keys"
          >
        </v-autocomplete>-->
        <autocomplete
          @enter="(e) => this.onSubmit('enter', e)"
          input-class="input-group input-group--hide-details input-group--placeholder input-group--text-field input-group--single-line theme--light"
          placeholder="ค้นหา"
          ref="autocomplete"
          @selected="(e) => this.onSubmit('selected', e)"
          :source="orderedSearchProduct"
        >
          <template slot="noResults">กด Enter เพื่อสร้างผลผลิต</template>
        </autocomplete>
      </v-layout>
      <v-spacer></v-spacer>
      <!-- <div class="">{{$appVersion}}</div> -->
    </v-toolbar>

    <!-- right click menu -->
    <v-menu absolute offset-y :position-x="x" :position-y="y" v-model="showMenu">
      <v-list>
        <!-- @click="addToFavorite(child.title, child.link)" -->
        <v-list-tile
          @click="addToFavorite(item.name, item.link)"
          :key="index"
          v-for="(item, index) in rightClickitems"
        >
          <v-list-tile-title>{{ item.title }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import _ from 'lodash/orderBy'
import Autocomplete from 'vuejs-auto-complete'

export default {
  name: 'navbar',
  components: {
    autocomplete: Autocomplete
  },
  data() {
    return {
      drawer: false,
      newfeatureColor: 'grey darken-2',
      title: this.$appName,
      showMenu: false,
      x: 0,
      y: 0,
      rightClickitems: [{ title: '', name: '', link: '' }],
      menuPersonalFavorite: [
        {
          title: 'Favorite',
          model: false,
          newfeature: false,
          children: []
        }
      ],
      menuItemsGroupMain: [{ icon: 'dashboard', title: 'Dashboard', link: '/dashboard' }],
      menuItemsGroupClassification: [
        {
          title: 'Classification',
          model: false,
          newfeature: false,
          children: [
            {
              icon: 'mdi-trophy-variant',
              title: 'Systematics',
              link: '/systematics',
              newfeature: false,
              favorite: 'star_border'
            },
            {
              title: 'Type Group',
              link: '/type-group',
              favorite: 'star_border'
            },
            {
              icon: 'local_offer',
              title: 'Type',
              link: '/type',
              favorite: 'star_border'
            }
          ]
        }
      ],
      menuItemsGroupProductManagement: [
        { icon: 'mdi-corn', title: 'All Product', link: '/product' }
      ],
      menuItemsGroupProductComponents: [
        {
          title: 'Product Components',
          model: false,
          newfeature: false,
          children: [
            { title: 'Product In Place', link: '/product-in-place' },
            {
              title: 'Parts',
              newfeature: false,
              children: [
                { title: 'Parts', link: '/parts' },
                { title: 'Parts Group', link: '/parts-group' }
              ]
            },
            { title: 'Unit', link: '/unit' },
            {
              title: 'Variety',
              newfeature: false,
              children: [
                { title: 'Variety', link: '/variety' },
                { title: 'Variety Group', link: '/variety-group' }
              ]
            },
            {
              title: 'Grade',
              newfeature: false,
              children: [
                { title: 'Grade', link: '/grade' },
                { title: 'Grade Group', link: '/grade-group' }
              ]
            },
            {
              title: 'Seasonality',
              newfeature: false,
              children: [
                {
                  title: 'Seasonality',
                  link: '/seasonality/visualize'
                },
                {
                  title: 'Seasonality Record',
                  link: '/seasonality/record'
                }
              ]
            },
            {
              title: 'Sources',
              newfeature: false,
              children: [
                {
                  title: 'Sources',
                  link: '/sources',
                  newfeature: false
                },
                {
                  title: 'Sources Index',
                  link: '/sources/index',
                  newfeature: false
                },
                {
                  title: 'Sources Refer',
                  link: '/sources/refer',
                  newfeature: false
                },
                {
                  title: 'Weighing Sources',
                  link: '/weighing-sources',
                  newfeature: false
                }
              ]
            },
            {
              title: 'Workflow',
              newfeature: false,
              children: [
                {
                  title: 'Workflow Group',
                  link: '/workflow-group'
                },
                {
                  title: 'Workflow Record',
                  link: '/workflow/record'
                },
                {
                  title: 'Workflow',
                  link: '/workflow'
                }
              ]
            },
            {
              title: 'Cooking',
              newfeature: false,
              children: [
                {
                  title: 'Menu',
                  link: '/cooking/menu'
                },
                {
                  title: 'Menu Type',
                  link: '/cooking/menu-type'
                },
                {
                  title: 'Method',
                  link: '/cooking/method'
                }
              ]
            },
            {
              title: 'Certification',
              newfeature: false,
              children: [
                {
                  icon: 'mdi-trophy-variant',
                  title: 'Benchmarking',
                  link: '/benchmarking',
                  newfeature: false
                },
                {
                  icon: 'mdi-trophy-variant',
                  title: 'Certificate',
                  link: '/certificate',
                  newfeature: false
                }
              ]
            },
            {
              title: 'Diseases',
              newfeature: false,
              children: [
                {
                  title: 'Causes Category',
                  link: '/causes-category',
                  newfeature: false
                },
                {
                  title: 'Caused',
                  link: '/caused',
                  newfeature: false
                },
                {
                  title: 'Diseases',
                  link: '/diseases',
                  newfeature: false
                },
                {
                  title: 'Disease In Farm',
                  link: '/disease-in-farm',
                  newfeature: false
                }
              ]
            },
            {
              title: 'Propagation',
              model: false,
              newfeature: false,
              children: [
                {
                  title: 'Methods',
                  link: '/propagation/methods',
                  newfeature: false
                },
                {
                  title: 'Propagation In Farm',
                  link: '/propagation/product',
                  newfeature: false
                }
              ]
            },
            {
              title: 'Properties',
              model: false,
              newfeature: false,
              children: [
                {
                  title: 'Properties',
                  link: '/properties',
                  newfeature: false
                },
                {
                  title: 'Properties Type',
                  link: '/properties/type',
                  newfeature: false
                },
                {
                  title: 'Properties In Farm',
                  link: '/properties/in-farm',
                  newfeature: false
                },
                {
                  title: 'Glycemic Index',
                  link: 'glycemic-index',
                  name: 'glycemic-index'
                },
                {
                  title: 'Glycemic Index In Farm',
                  link: '/glycemic-index-infarm',
                  name: '/glycemic-index-infarm'
                }
              ]
            },
            {
              title: 'Lifetime Extension',
              model: false,
              newfeature: false,
              children: [
                {
                  title: 'Period',
                  link: '/lifetime/period',
                  newfeature: false
                },
                {
                  title: 'Lifetime Record',
                  link: '/lifetime/record'
                }
              ]
            },
            {
              title: 'Festivals',
              newfeature: false,
              children: [
                {
                  title: 'Festivals',
                  link: '/festivals'
                },
                {
                  title: 'Festival Place',
                  link: '/festivals/places'
                },
                {
                  title: 'Festival Products',
                  link: '/festivals/products'
                }
              ]
            },
            {
              title: 'Factors',
              model: false,
              newfeature: false,
              children: [
                {
                  title: 'Factors',
                  link: '/factors',
                  newfeature: false
                },
                {
                  title: 'Variables',
                  link: '/factors/variables',
                  newfeature: false
                },
                {
                  title: 'Statistics',
                  link: '/factors/statistics',
                  newfeature: false
                },
                {
                  title: 'Parameters',
                  link: '/factors/parameters',
                  newfeature: false
                }
              ]
            },
            {
              newfeature: false,
              title: 'Geographical Indication (GI)',
              link: '/geographical-indication',
              name: '/geographical-indication'
            },
            {
              newfeature: false,
              title: 'Worker Record',
              link: '/worker-record'
            },
            { title: 'Equipment', link: '/equipment' },
            { title: 'Phases', link: '/phases' }
          ]
        }
      ],
      menuItemsGroupFarmerSpace: [
        {
          title: 'FarmerSpace.co',
          model: false,
          newfeature: true,
          children: [
            { title: 'Intern', link: '/farmerspace/intern' },
            { title: 'Content', link: '/farmerspace/content' },
            { title: 'Content Type', link: '/farmerspace/content-type' },
            { title: 'Topic', link: '/farmerspace/topic' },
            { title: 'Knowledge', link: '/farmerspace/knowledge' },
            { title: 'Question', link: '/farmerspace/question' },
            { title: 'Exam', link: '/farmerspace/exam' },
            {
              title: 'Raw Data',
              model: false,
              children: [
                {
                  title: 'Data Type',
                  link: '/raw-data/type'
                },
                {
                  title: 'Data',
                  link: '/raw-data'
                }
              ]
            }
          ]
        }
      ],
      menuItemsGroupCropperz: [
        {
          title: 'Cropperz.co',
          model: false,
          newfeature: true,
          children: [
            {
              title: 'Supplier',
              link: '/cropperz/supplier',
              newfeature: false
            },
            { title: 'Other', link: '/cropperz/other', newfeature: false },
            {
              title: 'Package Product',
              model: false,
              newfeature: true,
              children: [
                {
                  title: 'Package Product Type',
                  link: '/package-product/type'
                },
                { title: 'Package Product', link: '/package-product' }
              ]
            },
            {
              title: 'Logistics',
              model: false,
              newfeature: true,
              children: [
                { title: 'Motor Fuel', link: '/motor-fuel' },
                { title: 'Vehicle', link: '/vehicle' },
                { title: 'Vehicle Type', link: '/vehicle/type' },
                {
                  title: 'Vehicle Condition Type',
                  link: '/vehicle/condition/type'
                }
              ]
            }
          ]
        }
      ],
      menuItemsGroupControlPanel: [
        {
          title: 'Control Panel',
          model: true,
          newfeature: false,
          children: [
            { title: 'Site', link: '/site' },
            { title: 'Pages', link: '/pages' },
            {
              title: 'Banners',
              children: [
                {
                  title: 'Banner Positions',
                  link: '/banner-positions',
                  newfeature: false
                },
                { title: 'Banners', link: '/banners' }
              ]
            },
            { title: 'Unit Measure', link: '/unit/measure' },
            { title: 'Level', link: '/level' },
            { title: 'Color', link: '/color' },
            { title: 'Set Standard', link: '/value-standard' },

            {
              title: 'Area',
              link: '/area',
              newfeature: false
            },
            {
              title: 'Productivity',
              link: '/productivity',
              newfeature: false
            },
            {
              title: 'Places',
              children: [
                {
                  title: 'Country',
                  link: '/country',
                  newfeature: false
                },
                {
                  title: 'Thailand',
                  link: '/places/thailand',
                  newfeature: false
                }
              ]
            },
            {
              title: 'Soils',
              newfeature: false,
              children: [
                {
                  title: 'Soil Places',
                  link: '/soil-places'
                },
                {
                  title: 'Soil In Farm',
                  link: '/soil-in-farm'
                },
                {
                  title: 'Soil Color',
                  link: '/soil-color',
                  name: 'soil-color'
                },
                {
                  title: ' Soil Layer Name',
                  link: '/soil-layer-name',
                  name: 'soil-layer-name'
                },
                {
                  title: 'Soil Texture',
                  link: '/soil-texture'
                },
                { title: 'Soil Group', link: '/soil-group' },
                {
                  title: 'Soil Series',
                  link: '/soil-series'
                },
                {
                  title: 'Soil Series Detail',
                  link: '/soil-series-detail'
                },
                {
                  title: 'Soil Horizon',
                  link: '/soil-horizon'
                },
                {
                  title: 'Soil Structure',
                  link: '/soil-structure'
                }
              ]
            }
          ]
        }
      ],
      menuItemsGroupTechfarm: [
        {
          title: 'Techfarm',
          model: false,
          newfeature: true,
          children: [
            {
              title: 'Document Type',
              link: '/document/type'
            },
            {
              title: 'Document',
              link: '/document'
            }
          ]
        }
      ],
      menuItemsGroupUserManagement: [
        {
          title: 'User Management',
          model: false,
          newfeature: false,
          children: [
            { title: 'Users', link: '/users', newfeature: false },
            { title: 'Create admin', link: '/create-new-admin' },
            { title: 'Permission', link: '/permission', newfeature: false },
            { title: 'Set Privilege', link: '/privilege', newfeature: false },
            { title: 'Role', link: '/role', newfeature: false }
          ]
        }
      ],
      menuItemsGroupLogout: [
        { icon: 'account_box', title: 'Profile', link: '/profile' },
        { icon: 'exit_to_app', title: 'Logout', link: '' }
      ],
      // Search bar
      keys: '',
      states: [],
      // cropperz
      countCropperzOther: 0,
      colorFavorite: 'star_border',
      navbarUserProfile: [] // user profile
    }
  },
  watch: {
    $route() {
      if (sessionStorage.getItem('productcreated')) {
        this.getSearchProduct()
        sessionStorage.removeItem('productcreated')
      }
      // this.getSearchProduct()
    }
  },
  computed: {
    orderedSearchProduct() {
      return _(this.states, ['id', 'orders'], ['asc', 'asc'])
    },
    permissionUserManagement() {
      return this.$store.getters['Permission/getAll'].usermanagement
    },
    permissionControlPanel() {
      return this.$store.getters['Permission/getAll'].controlpanel
    }
  },
  async created() {
    if (localStorage.getItem('menuPersonalFavorite')) {
      this.menuPersonalFavorite = JSON.parse(localStorage.getItem('menuPersonalFavorite'))
    }
    this.getUserProfile()

    await this.$store.dispatch('Permission/fetch')
    this.$store.dispatch('Types/fetch')
    this.$store.dispatch('Place/fetchCountry')
    this.$store.dispatch('Place/fetchRegion')
    this.$store.dispatch('Place/fetchProvince')
    this.$store.dispatch('Place/fetchDistrict')
    this.$store.dispatch('Place/fetchSubDistrict')
    this.$store.dispatch('SeasonalityRecord/fetch')
    this.$store.dispatch('Variety/fetch')
    this.$store.dispatch('Parts/fetch')
    this.$store.dispatch('Sources/fetch')
    this.$store.dispatch('CropperzUsers/fetch')
    this.$store.dispatch('Product/search')
    this.$store.dispatch('Product/fetch')
    this.getCountCropperzOther()
    this.getSearchProduct()
  },
  methods: {
    show(e, title, link) {
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.rightClickitems[0].title = `Add ${title} To Favotie`
        this.rightClickitems[0].name = title
        this.rightClickitems[0].link = link
        this.showMenu = true
      })
    },
    async getUserProfile() {
      try {
        const response = await axios.get(`getUserProfile/${localStorage.getItem('userid')}`)
        this.navbarUserProfile = response.data[0]
      } catch (error) {
        throw new Error(error)
      }
    },
    deleteFromFavorite(link) {
      this.menuPersonalFavorite[0].children.splice(
        this.menuPersonalFavorite[0].children.findIndex(item => item.link == link),
        1
      )
      localStorage.setItem('menuPersonalFavorite', JSON.stringify(this.menuPersonalFavorite))
    },
    addToFavorite(title, link) {
      if (title && link) {
        const findLink = this.menuPersonalFavorite[0].children.findIndex(item => item.link == link)
        if (findLink < 0) {
          this.menuPersonalFavorite[0].children.push({
            title: title,
            link: link
          })
          localStorage.setItem('menuPersonalFavorite', JSON.stringify(this.menuPersonalFavorite))
          iziToast.info({
            title: `Add ${title} to favorite`,
            position: 'bottomRight'
          })
        } else {
          this.menuPersonalFavorite[0].children.splice(findLink, 1)
          localStorage.setItem('menuPersonalFavorite', JSON.stringify(this.menuPersonalFavorite))
          iziToast.info({
            title: `Deleted ${title} from favorite`,
            position: 'bottomRight'
          })
        }
      } else {
      }
    },
    async getCountCropperzOther() {
      try {
        const countCropperzOther = await axios.get(`/cropperz/other/get/count`)
        this.countCropperzOther += parseInt(countCropperzOther.data.count_quotation[0].count)
        this.countCropperzOther += parseInt(countCropperzOther.data.count_purchase[0].count)
        this.countCropperzOther > 99 ? (this.countCropperzOther = '99+') : this.countCropperzOther
      } catch (error) {
        throw new Error(error)
      }
    },
    async getSearchProduct() {
      try {
        this.states = []
        const states = await axios.get(`search/product`)
        states.data.forEach(element => {
          // this.states = response.data.ProductsTHA
          this.states.push({
            id: element.productid,
            name: element.productname,
            orders: element.orders
          })
        })
      } catch (error) {
        throw new Error(error)
      }
    },
    onSubmit(condition, item) {
      let findItem = null
      switch (condition) {
        case 'selected':
          this.keys = item.value
          if (this.keys !== '') {
            this.$router.push({ path: `/product/${this.keys}` }) // -> /product/123
          } else {
            this.$router.push({ path: '/' })
          }
          break

        case 'enter':
          this.states.forEach(element => {
            if (item == element.name) {
              findItem = element.id
            }
          })
          findItem
            ? this.$router.push({ path: `/product/${findItem}` }) // -> /product/123
            : this.$router.push({
                path: `/product/create/THA?productname=${item}`
              })
          break

        default:
          break
      }
      this.$refs.autocomplete.clearValues()
    },
    doLogout() {
      swal({
        title: 'ออกจากระบบ',
        width: '20rem',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#000',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก',
        buttonsStyling: true,
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          axios
            .delete(
              `/deleteSessionLogin/${this.$session.get('userid')}/${this.$session.get(
                'session-id'
              )}`
            )
            .then(function(response) {})
            .catch(function(error) {
              throw new Error(error)
            })
          // delete localStorage
          localStorage.removeItem('userid')
          localStorage.removeItem('token')
          localStorage.removeItem('roleid')

          // delete session
          this.$store.commit('Permission/CLEAR_STATE')
          this.$session.destroy()
          this.$router.push('/login')
        } else if (result.dismiss === swal.DismissReason.cancel) {
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
$color: #151b26;
#main-navbar::-webkit-scrollbar {
  display: none;
}
#main-navbar {
  cursor: pointer;
  background-color: $color;
  & .navbar-logo-background {
    background-color: transparent;
    & .navbar-logo-img {
      vertical-align: middle;
      padding-top: 10px;
      // margin-left: 10px;
      width: 80px;
    }
  }
}
.subheader-group1 {
  font-size: 10px !important;
  font-weight: 300;
  text-transform: uppercase;
}
#toolbar-desktop {
  background-color: $color;
  & .logo-img {
    vertical-align: middle;
    width: 150px;
  }
}
.font-newfeature {
  font-size: 10px !important;
}
.search-box {
  box-shadow: none !important;
  border-radius: 16px !important;
  border: 1px solid #ccc !important;
}
.none-group-menu {
  padding-left: 44px;
}
.v-list__group--active:after,
.v-list__group--active:before {
  background: transparent !important;
}
.favorite-menu {
  margin-right: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/TheNavbar.vue